<div class="toppic">
  <div class="fa-icon-content" fxLayoutAlign="center center">
    <mat-icon *ngIf="menuTopic.icon">
      {{ menuTopic.icon }}
    </mat-icon>

    <img
      *ngIf="!menuTopic.icon && menuTopic.iconUrl"
      [src]="menuTopic.iconUrl"
      alt=""
    />
  </div>
  <div class="detail-text-toppic">
    <span class="text-toppic">
      {{ menuTopic.title | translate }}
    </span>
    <span class="text-sub-toppic">
      {{ menuTopic.subtitle | translate }}
    </span>
  </div>
</div>
